import { Injectable } from '@angular/core';
import { UpsertWorkoutStep } from '@me-fit-mono/typings';

export interface PendingOnboardingWorkout {
  name: string;
  description: string;
  steps: UpsertWorkoutStep[];
}

@Injectable({
  providedIn: 'root',
})
export class PendingOnboardingWorkoutService {
  private readonly storageKey = 'pending-onboarding-workout-v1';

  save(workout: PendingOnboardingWorkout) {
    window.localStorage.setItem(this.storageKey, JSON.stringify(workout));
  }

  get(): PendingOnboardingWorkout | null {
    const serializedWorkout = window.localStorage.getItem(this.storageKey);

    if (!serializedWorkout) {
      return null;
    }

    try {
      const workout: unknown = JSON.parse(serializedWorkout);

      if (!this.isPendingOnboardingWorkout(workout)) {
        this.clear();
        return null;
      }

      return workout;
    } catch {
      this.clear();
      return null;
    }
  }

  clear() {
    window.localStorage.removeItem(this.storageKey);
  }

  private isPendingOnboardingWorkout(value: unknown): value is PendingOnboardingWorkout {
    if (!value || typeof value !== 'object') {
      return false;
    }

    const workout = value as Record<string, unknown>;

    return typeof workout['name'] === 'string'
      && typeof workout['description'] === 'string'
      && Array.isArray(workout['steps']);
  }
}
